import * as types from "./mutation_types";
const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const getItems = ({ commit }, values) => {
  commit(types.LIGNE_ROB_STRUCT_TOGGLE_LOADING);

  axios
    .get(
      URL_BACKEND +
        "api-rob/lignesStruct/" +
        values.robId +
        "/" +
        values.structId +
        "/"
    )
    .then((response) => {
      commit(types.LIGNE_ROB_STRUCT_TOGGLE_LOADING);
      commit(types.LIGNE_ROB_STRUCT_SET_ITEMS, response.data);
    })
    .catch((e) => {
      commit(types.LIGNE_ROB_STRUCT_SET_ITEMS, []);
      commit(types.LIGNE_ROB_STRUCT_TOGGLE_LOADING);
      commit(types.LIGNE_ROB_STRUCT_SET_ERROR, e.message);
    });
};
